import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_AUTOMATION, APP_FILE_MANAGE_AUTOMATION } from "./automation.constants";

const Automation = Loadable(
  lazy(() =>
    import("./Automation").then(({ Automation }) => ({
      default: Automation,
    }))
  )
);
const ManageAutomation = Loadable(
  lazy(() =>
    import("./ManageAutomation").then(
      ({ ManageAutomation }) => ({
        default: ManageAutomation,
      })
    )
  )
);

export const automationRoutes = [
 {
          path: `${APP_FILE_AUTOMATION}`,
          exact: true,
          element: (
            <AuthorizedRoute allowFullAccess moduleKeys={[]}>
              <Automation />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_MANAGE_AUTOMATION}`,
          exact: true,
          element: (
            <AuthorizedRoute allowFullAccess moduleKeys={[]}>
              <ManageAutomation />
            </AuthorizedRoute>
          ),
        },
         {
                path: `${APP_FILE_MANAGE_AUTOMATION}/:automationCode`,
                exact: true,
                element: (
                  <AuthorizedRoute allowFullAccess moduleKeys={[]}>
                    <ManageAutomation />
                  </AuthorizedRoute>
                ),
              },
];
